<template>
  <v-container fluid d-flex fill-height justify-center align-start align-lg-center id="scrolling-techniques-7" class="overflow-y-auto px-4" key="settings">
    <v-row class="max-w">
      <v-col cols="12" class="pb-0">
        <div class="headline font-weight-bold relative px-4 my-2 pb-1 text--primary">
          {{ $t('Uzytkownicy') }}
          <v-fab-transition>
            <v-btn
              absolute
              fab
              bottom
              right
              color="primary"
              v-show="showAdd"
              :to="'/add-user/' + controllerId"
              :loading="loading"
              :disabled="loading"
            >
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </v-fab-transition>
        </div>
      </v-col>
      <v-col cols="12">
        <v-slide-x-reverse-transition
          group
          hide-on-leave
        >
          <v-card 
            v-for="(item, i) in users"
            class="mx-auto mb-1 py-1 br-3"
            :key="i"
            :to="'/edit-user/' + item.email + '/' + controllerId"
          >
            <v-list-item one-line>
              <v-list-item-icon>
                <v-icon v-text="icons[item.permission]"></v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title class="text--primary">{{ item.email }}</v-list-item-title>
              </v-list-item-content>
              <v-list-item-icon>
                <v-icon>mdi-chevron-right</v-icon>
              </v-list-item-icon>
            </v-list-item>
          </v-card>
        </v-slide-x-reverse-transition>
      </v-col>

    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  data: () => ({
    showAdd: false
  }),
  computed: {
    ...mapGetters([
      'controllers',
      'controllerById'
    ]),
    controllerId() {
      return this.$route.params.controllerId;
    },
    moduleName() {
      return 'c' + this.controllerId;
    },
    users() {
      return this.$store.getters['users/users']
    },
    icons() {
      return this.$store.getters['users/icons']
    },
    loading() {
      return this.$store.state.users.loading
    }
  },
  created () {
    if (!(this.$store && this.$store.state && this.$store.state[this.moduleName])) {
      this.$router.push({ path: '/dashboard/' + this.controllerId });
    } else {
      this.getUsers(false)
      .then(res => {
        if (res.error) {
          this.$store.commit("alert", {
            color: "error",
            text: res.error.code
          });
        }
      });
    }
  },
  mounted () {
    setTimeout(() => { this.showAdd = true; }, 200);
  },
  methods: {
    getUsers(forced) {
      return this.$store.dispatch(`users/getUsers`, { controllerId: this.controllerId, forced: forced })
    },
  }
}
</script>

<style>

</style>
